"use client";

import React from "react";
import {
  Card,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import useFetchWithAuth from "../../../../features/hooks/useFetchWithAuth";

const ProductsListContent = () => {
  const { data, loading, error } = useFetchWithAuth("/scripts/products/");
  const navigate = useNavigate();

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const handleRowClick = (product) => {
    const query = new URLSearchParams();
    if (product?.crm) query.set("crm", String(product.crm));
    if (product?.product_id)
      query.set("product_id", String(product.product_id));
    const suffix = query.toString() ? `?${query.toString()}` : "";
    navigate(`/operator/scripts/${product.id}${suffix}`);
  };

  return (
    <Card
      sx={{
        boxShadow: "none",
        borderRadius: "7px",
        mb: "25px",
        padding: { xs: "18px", sm: "20px", lg: "25px" },
      }}
      className="rmui-card"
    >
      <Box>
        <Typography
          variant="h1"
          sx={{ fontSize: "24px", marginBottom: "20px", fontWeight: 600 }}
        >
          Скрипти та характеристики
        </Typography>

        <TableContainer
          component={Paper}
          sx={{ boxShadow: "none", borderRadius: "7px" }}
          className="rmui-table border"
        >
          <Table sx={{ minWidth: 650 }} aria-label="Products Table">
            <thead className="bg-f6f7f9">
              <TableRow
                sx={{
                  th: {
                    fontWeight: "500",
                    padding: "10px 20px",
                    fontSize: "14px",
                  },
                }}
              >
                <TableCell className="text-black border-bottom">
                  Назва товару
                </TableCell>
                <TableCell className="text-black border-bottom">
                  Кількість
                </TableCell>
                <TableCell className="text-black border-bottom">Ціна</TableCell>
              </TableRow>
            </thead>

            <TableBody>
              {data?.map((product) => (
                <TableRow
                  key={product.product_id}
                  sx={{
                    td: { padding: "14px 20px", fontSize: "14px" },
                    cursor: "pointer",
                  }}
                  onClick={() => handleRowClick(product)}
                >
                  <TableCell className="border-bottom">
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "13px",
                      }}
                    >
                      <Box sx={{ flexShrink: 0 }}>
                        <img
                          src={product.image}
                          alt={product.title}
                          width={40}
                          height={40}
                          style={{ borderRadius: "7px" }}
                        />
                      </Box>
                      <Typography
                        sx={{ fontSize: "15px", fontWeight: "500" }}
                        className="text-black"
                      >
                        {product.title}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell className="border-bottom">
                    {product.total_quantity}
                  </TableCell>
                  <TableCell className="border-bottom">
                    {product.price}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Card>
  );
};

export default ProductsListContent;
